import { createReducer, createSelector } from '@reduxjs/toolkit';
import {
  deleteInvitationSourceMappingsSuccess,
  deleteInvitationSourceSuccess,
  getAllHearingsSuccess,
  getHearingSuccess,
  getInvitationNotificationsForHearingSuccess,
  getPaginatedHearingsSuccess,
  uploadCsvInviteesSuccess,
  uploadExcelInviteesSuccess,
  uploadInvitationGroupInviteesSuccess,
  uploadPersonalInviteesSuccess,
} from '../actions/api';
import {
  getIncludedData,
  selectAllFromApiState,
} from '../helpers/selectorHelpers';
import { COMPANY_INCLUDE } from '../../constants/api';
import { updateDtoList } from '../helpers/reducerHelpers';
import { getEntityId, getRelId } from '../helpers/apiHelpers';
import { allCompanyHearingRolesWithRoleByHearingIdSelector } from './companyHearingRoleSlice';
// -------- Overview --------

// Company is included in the following endpoints
//  - GET /hearing

// -------- Reducer --------
const companyReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder
      .addCase(getAllHearingsSuccess, (state, action) => {
        const data = getIncludedData(action);
        const companies = data.filter(
          (include) => include.type === COMPANY_INCLUDE,
        );
        return updateDtoList(state, 'all', companies);
      })
      .addCase(getHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const companies = data.filter(
          (include) => include.type === COMPANY_INCLUDE,
        );
        return updateDtoList(state, 'all', companies);
      })
      .addCase(getPaginatedHearingsSuccess, (state, action) => {
        const data = getIncludedData(action);
        const companies = data.filter(
          (include) => include.type === COMPANY_INCLUDE,
        );
        return updateDtoList(state, 'all', companies);
      })
      .addCase(uploadCsvInviteesSuccess, (state, action) => {
        const data = getIncludedData(action);
        const companies = data.filter(
          (include) => include.type === COMPANY_INCLUDE,
        );
        return updateDtoList(state, 'all', companies);
      })
      .addCase(uploadExcelInviteesSuccess, (state, action) => {
        const data = getIncludedData(action);
        const companies = data.filter(
          (include) => include.type === COMPANY_INCLUDE,
        );
        return updateDtoList(state, 'all', companies);
      })
      .addCase(uploadPersonalInviteesSuccess, (state, action) => {
        const data = getIncludedData(action);
        const companies = data.filter(
          (include) => include.type === COMPANY_INCLUDE,
        );
        return updateDtoList(state, 'all', companies);
      })
      .addCase(uploadInvitationGroupInviteesSuccess, (state, action) => {
        const data = getIncludedData(action);
        const companies = data.filter(
          (include) => include.type === COMPANY_INCLUDE,
        );
        return updateDtoList(state, 'all', companies);
      })
      .addCase(deleteInvitationSourceSuccess, (state, action) => {
        const data = getIncludedData(action);
        const companies = data.filter(
          (include) => include.type === COMPANY_INCLUDE,
        );
        return updateDtoList(state, 'all', companies);
      })
      .addCase(deleteInvitationSourceMappingsSuccess, (state, action) => {
        const data = getIncludedData(action);
        const companies = data.filter(
          (include) => include.type === COMPANY_INCLUDE,
        );
        return updateDtoList(state, 'all', companies);
      })
      .addCase(getInvitationNotificationsForHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const companies = data.filter(
          (include) => include.type === COMPANY_INCLUDE,
        );
        return updateDtoList(state, 'all', companies);
      });
  },
);

// -------- Selectors --------
const selectGetAllCompanies = (state) =>
  selectAllFromApiState(state, 'company');

const allCompaniesSelector = createSelector(
  selectGetAllCompanies,
  (companies) => companies,
);

const companyByUserSelector = (user) =>
  createSelector(allCompaniesSelector, (companies) =>
    companies.find((company) => company.id === getRelId(user, 'company')),
  );

const allCompaniesInRoleByHearingIdSelector = (hearingRole, hearingId) =>
  createSelector(
    [
      allCompaniesSelector,
      allCompanyHearingRolesWithRoleByHearingIdSelector(hearingRole, hearingId),
    ],
    (companies, companyHearingRoles) =>
      companies.filter((company) =>
        companyHearingRoles.some(
          (companyHearingRole) =>
            getRelId(companyHearingRole, 'company') === getEntityId(company),
        ),
      ),
  );

export {
  allCompaniesSelector,
  companyByUserSelector,
  allCompaniesInRoleByHearingIdSelector,
};
export default companyReducer;
